export default function Table({
  columns = [],     // [{ key: "name", label: "نام" }]
  data = [],        // [{ name: "علی", age: 21 }]
  isLTR = "",
  isEnglish = [],
  haveScroll = false,
  maxHeight = "",
  footer = null,
  scrollRootRef = null,
}) {
  
  return (
    <div
      ref={haveScroll ? scrollRootRef : null}
      className="w-full min-h-0 flex-1 overflow-auto rounded-t-2xl"
      style={{ maxHeight: haveScroll ? maxHeight : "none" }}
    >
      <table className={`w-full min-w-max min-h-0 text-sm text-zi-text-light text-nowrap dark:text-zi-text-dark border-collapse`}>
        <thead>
          <tr>
            {columns.map((col, i) => (
              <th
                key={i}
                className={`sticky top-0 z-10 bg-zi-bg1-light dark:bg-zi-bg1-dark border-b border-b-zi-blue-light font-medium px-3 py-3`}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className={`divide-y divide-zi-border-light dark:divide-zi-border-dark/50`}>
          {data.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className={`hocus:bg-zi-bg1-light/50 dark:hocus:bg-zi-bg1-dark/50
              `}
            >
              {columns.map((col, colIndex) => (
                <td
                  key={colIndex}
                  className={`text-center px-3 py-3 ${
                    isLTR || (Array.isArray(isEnglish) && isEnglish.includes(colIndex))
                      ? "[direction:ltr]"
                      : ""
                  }`}
                >
                  {col.render ? col.render(row[col.key], row) : row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {footer}
    </div>
  );
}
